export const SETTING_KEYS = {
  // Groups
  GENERAL_GROUP: 'general',
  SOCIAL_MEDIA_GROUP: 'social_media',
  HOURS_GROUP: 'hours',
  SEO_GROUP: 'seo',
  OTHERS_GROUP: 'others',
  IMAGES_AND_LOGOS_GROUP: 'images_and_logos',
  // General Settings
  SITE_NAME: 'site_name',
  BUSINESS_NAME: 'business_name',
  CONTACT_NUMBER: 'contact_number',
  WHATS_APP_CONTACT: 'whats_app_contact',
  EMAIL_ADDRESS: 'email_address',
  ADDRESS: 'address',
  ZIP_CODE: 'zip_code',
  // Opening & Closing hours
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thrusday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
  OPENING_CLOSING: 'opening_closing',
  // Social media links
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  LINKEDIN: 'linkedin',
  YOUTUBE: 'youtube',
  // App links
  GOOGLE_PLAY: 'google_play',
  APPLE_STORE: 'apple_store',
  IOS_APP_LINK: 'ios_app_link',
  ANDROID_APP_LINK: 'android_app_link',
  //SEO
  META_TITLE: 'meta_title',
  META_DESCRIPTION: 'meta_description',
  META_KEYWORDS: 'meta_keywords',
  // Others
  AUTHORIZED_SIGNATORY: 'authorized_signatory',
  AUTHORIZED_SIGNATORY_DESIGNATION: 'authorized_signatory_designation',

  // Images & Logos
  SITE_LOGO: 'site_logo',
  FAVICON: 'favicon',
  REPORT_LOGO: 'report_logo',
  INVOICE_LOGO: 'invoice_logo',

};